import { render, staticRenderFns } from "./ChartComponentG2.vue?vue&type=template&id=55388f44&scoped=true&"
import script from "./ChartComponentG2.vue?vue&type=script&lang=js&"
export * from "./ChartComponentG2.vue?vue&type=script&lang=js&"
import style0 from "./ChartComponentG2.vue?vue&type=style&index=0&id=55388f44&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55388f44",
  null
  
)

export default component.exports